import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subject } from 'rxjs';
import { TableEditorDialogBoxComponent } from './table-editor-dialog-box.component';

@Injectable()
export class TableEditorDialogBoxRef {
  private opened = new Subject<TableEditorDialogBoxData>();
  private closed = new Subject<void>();
  private dialogRef: MatDialogRef<TableEditorDialogBoxComponent> | null = null;

  constructor(private dialog: MatDialog) {
    this.dialog.afterOpened.subscribe((ref) => {
      if (ref.componentInstance instanceof TableEditorDialogBoxComponent) {
        this.dialogRef = ref;
        this.dialogRef.afterClosed().subscribe((r) => {
          this.closed.next();
        });
        this.opened.next({ title: this.convertToTitleKey(this.dialogRef.componentInstance.rootPath) });
      }
    });
  }

  get opened$(): Observable<TableEditorDialogBoxData> {
    return this.opened.pipe();
  }
  get closed$(): Observable<void> {
    return this.closed.pipe();
  }

  submit(): void {
    if (this.dialogRef) {
      this.dialogRef.componentInstance.onOk();
    }
  }

  cancel(): void {
    if (this.dialogRef) {
      this.dialogRef.componentInstance.onCancel();
    }
  }

  private convertToTitleKey(rootPath: string): string {
    let lastDotIndex = rootPath.lastIndexOf('.');
    return 'dialog.title.' + rootPath.substr(0, lastDotIndex);
  }
}

export class TableEditorDialogBoxData {
  public title: string;
}
